import { render, staticRenderFns } from "./SanadeusPageHeader.vue?vue&type=template&id=e0a968f2&scoped=true&"
import script from "./SanadeusPageHeader.vue?vue&type=script&lang=js&"
export * from "./SanadeusPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./SanadeusPageHeader.vue?vue&type=style&index=0&id=e0a968f2&prod&lang=css&"
import style1 from "./SanadeusPageHeader.vue?vue&type=style&index=1&id=e0a968f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a968f2",
  null
  
)

export default component.exports